<create-group [categories]="images"></create-group>
